

exports.__esModule = true;
exports.$xoSidebarInstallmentOptionsPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-page-components/src/aside-header/directive');

require('xo-wallet-components/src/installment-options/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
    tag: 'xo-sidebar-installment-options-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/directive.js
// module id = ./pages/xo-sidebar-installment-options/directive.js
// module chunks = 0